export class FilterClusterINModel {
  idComune: string
}